const OnboardingEmitter = {
    events: {},
    dispatch: function (event, data) {
        if (!this.events[event]) return;
        this.events[event].forEach(callback => callback(data))
    },
    subscribe: function (event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    },
    unsubscribe: function () {
        Object.keys(this.events).forEach(key => delete this.events[key]);
    }
    
}

module.exports = { OnboardingEmitter };